import {
  getBenchmarkDataFromAnyBenchmark,
  getValueFromPercentile,
} from "lib/shared/autobenchmarking";
import { FieldType } from "prisma/cm/client";

import { FieldDefinition, UsageModel } from "../../fieldDefinition";
import { FieldValueResolver } from "../../FieldValueResolver";
import { FieldSourceType } from "../../types";

export function fromBenchmarkPercentile(targetPercentile: number): FieldDefinition {
  return new FieldDefinition({
    id: `benchmarkPercentile${targetPercentile}`,
    baseModel: UsageModel.User,
    fieldSourceType: FieldSourceType.BENCHMARK,
    valueGetter: (user) => {
      if (!FieldValueResolver.validateAsUser(user)) {
        return null;
      }

      if (!user || !user.benchmark || !user.benchmark.data) {
        return null;
      }

      const payPointData = getBenchmarkDataFromAnyBenchmark(user.benchmark!);

      if (!payPointData) {
        return null;
      }

      return getValueFromPercentile({
        percentile: targetPercentile,
        curvePoints: payPointData,
      });
    },
    label: `Benchmark Percentile ${targetPercentile}`,
    fieldTypes: [FieldType.DOLLAR],
  });
}
